/**************************************************
 * Nombre:       Producto_Metodos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import ic_visa from '../../../../Recursos/ic_visa.svg'
import ic_amex from '../../../../Recursos/ic_amex.svg'
import ic_master from '../../../../Recursos/ic_master.svg'
import ic_siste from '../../../../Recursos/ic_siste.png'
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";


const Producto_Metodos = () => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                border: 1,
                borderColor: '#00000020',
                borderRadius: 4,
                p: 3
            }}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: !masSM ? 24 : 32, fontWeight: 600, lineHeight: 1.1}}>
                    Métodos de pago
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                <Typography sx={{fontSize: !masSM ? 16 : 20, fontWeight: 400, lineHeight: 1.1}}>
                    Tarjetas de crédito
                </Typography>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{mt: 2}}
                spacing={1}
            >

                {items.map((item, i) => {
                    return (
                        <Grid container size={{xs: 3, sm: 3, md: 2}} sx={{justifyContent: 'flex-start'}}>
                            <img src={item} width={'100%'} height={'auto'}/>
                        </Grid>
                    )
                })}


            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                <Typography sx={{fontSize: !masSM ? 16 : 20, fontWeight: 400, lineHeight: 1.1}}>
                    Tarjetas de crédito
                </Typography>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{mt: 2}}
                spacing={2}
            >

                {items2.map((item, i) => {
                    return (
                        <Grid container size={{xs: 3, sm: 3, md: 2}} sx={{justifyContent: 'flex-start'}}>
                            <img src={item} width={'100%'} height={'auto'}/>
                        </Grid>
                    )
                })}


            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                <Typography sx={{fontSize: !masSM ? 16 : 20, fontWeight: 400, lineHeight: 1.1}}>
                    Compra con Sistecrédito
                </Typography>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{mt: 2}}
            >


                <img src={ic_siste} width={160} height={'auto'}/>


            </Grid>

        </Grid>
    )

}
export default Producto_Metodos

const items = [ic_visa, ic_amex, ic_master]

const items2 = [ic_visa, ic_master]